/* unplugin-vue-components disabled */import script from "./ComplaintHarmfulComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintHarmfulComponents.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintHarmfulComponents.vue?vue&type=style&index=0&id=21f2efa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f2efa6"]])

export default __exports__